/**
 * Created by Languagenut on 19/06/2019.
 */

import React  from 'react';
import {ProgressBar , Col , Row , Modal , Button, Form} from 'react-bootstrap'
import Translation from '../../store/internationalization-store.js'
import ClassesService from '../../services/classes-service.js';

export default class TextPopup extends React.Component {

    constructor(props) {
        super();
        this.props = props;

        console.log(this.props);

        this.state = {
            numberOfStudents: 10,
            teacherName:"",
            email:""
        };
    }

    componentWillReceiveProps(props){
        this.props = props;
        this.state = {
            value:this.props.value || "",
            numberOfStudents: 5,
            teacherName:"",
            email:""
        };
    }

    makenew(){
        if (this.state.thinking != true) {
            this.setState({
                thinking:true,
            })
            ClassesService.addLicenses(this.state.numberOfStudents, this.state.teacherName, this.state.email).then(function(response){
                this.props.onHide();
                this.setState({
                    thinking:false,
                })
            }.bind(this));
        }
    }

    onChange(event){
        this.setState({
            numberOfStudents: event.target.value
        });
    }

    onChangeName(event){
        this.setState({
            teacherName: event.target.value
        });
    }

    onChangeEmail(event){
        this.setState({
            email: event.target.value
        });
    }
    
    render() {

        var disabled = !(this.state.teacherName != "" && this.state.email != "")

        let Buttons = <Modal.Footer>{[<Button disabled={disabled} onClick={this.makenew.bind(this)}>{Translation.get(12667 , 'Create')}</Button>]}</Modal.Footer>
        var body = <Row className="strong">
                <Col md={12}>
                    <Form.Group onChange={this.onChange.bind(this)}>
                        <Form.Label>Number of licenses</Form.Label>
                        <Form.Control as="select">
                        <option>5</option>
                        <option>10</option>
                        <option>25</option>
                        <option>50</option>
                        <option>100</option>
                        <option>250</option>
                        <option>500</option>
                        <option>750</option>
                        <option>1000</option>
                        </Form.Control>
                    </Form.Group>
                </Col>
                <br/>
                <Col md={12}>
                    <Form.Group onChange={this.onChangeName.bind(this)}>
                        <Form.Label>Name of person buying licences</Form.Label>
                        <Form.Control></Form.Control>
                    </Form.Group>
                </Col>
                <Col md={12}>
                    <Form.Group onChange={this.onChangeEmail.bind(this)}>
                        <Form.Label>Email address</Form.Label>
                        <Form.Control type="email"></Form.Control>
                    </Form.Group>
                </Col>
            </Row>
        if(this.state.thinking) {
            body = <ProgressBar animated now={45} />
        }

        return (
            <Modal
                {...this.props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                >
                <Modal.Header closeButton>
                    <h2>Add New Licenses</h2>
                </Modal.Header>
                <Modal.Body>
                    {body}
                </Modal.Body>
                {Buttons}
            </Modal>
        );
    }
}